export const DOTS_TYPES = [
  { id: 'square', label: 'Square' },
  { id: 'rounded', label: 'Rounded' },
  { id: 'dots', label: 'Dots' },
  { id: 'classy', label: 'Classy' },
  { id: 'extra-rounded', label: 'Extra rounded' },
];

export const CORNER_SQUARE_TYPES = [
  { id: 'square', label: 'Square' },
  { id: 'extra-rounded', label: 'Rounded' },
  { id: 'dot', label: 'Dot' },
];

export const CORNER_DOT_TYPES = [
  { id: 'square', label: 'Square' },
  { id: 'dot', label: 'Dot' },
];

export const FRAME_TYPES = [
  { id: 'none', label: 'None' },
  { id: 'banner', label: 'Banner' },
  { id: 'border', label: 'Border' },
  { id: 'rounded', label: 'Rounded' },
];

export const FRAME_FONTS = [
  { id: 'sans-serif', label: 'Sans-serif' },
  { id: 'serif', label: 'Serif' },
  { id: 'monospace', label: 'Monospace' },
];

export function buildQrStylingOptions(data, style, renderSize) {
  const size = renderSize ?? style.size;

  return {
    width: size,
    height: size,
    type: 'canvas',
    data,
    margin: style.margin,
    qrOptions: { errorCorrectionLevel: style.logoUrl ? 'H' : 'M' },
    dotsOptions: {
      color: style.fgColor,
      type: style.dotsType,
    },
    cornersSquareOptions: {
      color: style.fgColor,
      type: style.cornersSquareType,
    },
    cornersDotOptions: {
      color: style.fgColor,
      type: style.cornersDotType,
    },
    backgroundOptions: {
      color: style.bgColor,
    },
    ...(style.logoUrl
      ? {
          image: style.logoUrl,
          imageOptions: {
            crossOrigin: 'anonymous',
            margin: style.logoMargin,
            imageSize: style.logoSize,
            hideBackgroundDots: true,
          },
        }
      : {}),
  };
}
